import { HttpClientFactory } from '@/shared/services/HttpClientFactory';
import { storageService } from '@/shared/services/storageService';

const ORGANIZATION_ENDPOINT = '/api/v1/auth/public/organization';

function organizationLocale() {
  const locale = storageService.session.get('lang');

  if (locale === 'he') { return 'iw'; }

  return locale;
}

export const getOrganization = async () => (HttpClientFactory.baseClient ? HttpClientFactory.baseClient
  .get(organizationLocale() ? `${ORGANIZATION_ENDPOINT}/locale/${organizationLocale()}` : ORGANIZATION_ENDPOINT)
  .then(res => res)
  .then(res => res.data)
  .catch(error => {
    throw error;
  }) : {});
